import { lazy } from 'react';
import Loadable from '../../components/Loadable';
import { AddProductsProvider } from "../../contexts/productContext/AddProductContext";
import { FeatureProductsProvider } from "../../contexts/productContext/FeatureProductContext";
import { ProductDetailProvider } from "../../contexts/productContext/ProductDetailContext";
import { SaleProductsProvider } from "../../contexts/productContext/SaleProductContext";
import { user } from '../../utils/local-user';
import AddProductNewFragment from './addProduct/views/AddProductNewFragment';

// import { ImageStoreProvider } from '../../contexts/productContext/AddImageContext';

const AllProducts = Loadable(lazy(() => import('./shared/allProducts/AllProducts')));
const SaleProducts = Loadable(lazy(() => import('./shared/saleProducts/SaleProducts')));
const FeaturedProducts = Loadable(lazy(() => import('./shared/featuredProducts/FeaturedProducts')));
const AddProductFragment = Loadable(lazy(() => import('./addProduct/views/AddProductFragment')));
const ProductDetailFragment = Loadable(lazy(() => import('./detail/ProductDetailFragment')));

const productsRoutes = [
  { path: '/product/all', element: <AllProducts /> },
  { path: '/product/all/:sorting', element: <AllProducts /> },
  { path: '/product/sale', element: <SaleProductsProvider><SaleProducts /></SaleProductsProvider> },
  { path: '/product/featured', element: <FeatureProductsProvider><FeaturedProducts /></FeatureProductsProvider> },
  { path: '/product/new/add', element: <><AddProductNewFragment /></> },
  { path: '/product/add', element: <AddProductsProvider><AddProductFragment /></AddProductsProvider> },
  {
    path: '/product/add/:id', element: <AddProductsProvider>
      {/* <ImageStoreProvider> */}
      <AddProductFragment />
      {/* </ImageStoreProvider> */}

    </AddProductsProvider>
  },
  { path: '/product/detail/:id', element: <ProductDetailProvider><ProductDetailFragment /></ProductDetailProvider> },
].filter(x => {
  const serviceArea = user();
  if (!isNaN(parseInt(serviceArea))) {
    if (x.path === '/product/featured') {
      return false;
    }
    if (x.path === '/product/sale') {
      return false;
    }
  }

  return true;

})

export default productsRoutes;
